import { __privateAdd, SPEC_VERSION, __privateGet, Message, APP_LOCATION, EventNames, __privateSet, debugLogger, __privateMethod, MFE_INSTANCE_ID_QUERY_PARAM, uuid, HostModes, StandaloneNotAllowedError, MFE_LOCATION, StandaloneDispatchError, InsecureDispatchError } from './chunk-7JJRYS2Y.js';
export { constants_exports as Constants, errors_exports as Errors, message_exports as Message, payloads_exports as Payloads } from './chunk-7JJRYS2Y.js';

// src/mfe.ts
var _hostMode, _hostOrigin, _allowStandalone, _debug, _queryParams, _StorableMfe_instances, embedded_fn, detectHostMode_fn, _onMessageEvent, listenForMessages_fn, postToHost_fn;
var StorableMfe = class extends EventTarget {
  constructor(name, options) {
    var _a;
    super();
    __privateAdd(this, _StorableMfe_instances);
    this.version = SPEC_VERSION;
    __privateAdd(this, _hostMode);
    __privateAdd(this, _hostOrigin);
    __privateAdd(this, _allowStandalone);
    __privateAdd(this, _debug);
    __privateAdd(this, _queryParams);
    __privateAdd(this, _onMessageEvent, (event) => {
      const incomingMessage = event.data;
      __privateGet(this, _debug).call(this, " <- MFE from Host", incomingMessage);
      if (!event.source) {
        __privateGet(this, _debug).call(this, " <- MFE from Host", "event does not have a source, ignoring message");
        return;
      }
      const message = new Message(incomingMessage);
      if (!message.isFrom(APP_LOCATION) || !message.instanceUuid) {
        return;
      }
      if (message.version !== this.version) {
        console.warn(
          `Received message from host with spec version ${message.version}, but MFE is on spec version ${this.version}.`
        );
      }
      if (message.isNamed(EventNames.EMBED_ACKNOWLEDGED)) {
        if (__privateGet(this, _hostOrigin)) {
          return;
        }
        __privateSet(this, _hostOrigin, event.origin);
      }
      this.dispatchEvent(new CustomEvent(message.name, { detail: message }));
    });
    __privateSet(this, _debug, debugLogger((_a = options == null ? undefined : options.debug) != null ? _a : false));
    this.name = name;
    __privateSet(this, _hostMode, __privateMethod(this, _StorableMfe_instances, detectHostMode_fn).call(this));
    __privateSet(this, _allowStandalone, (options == null ? undefined : options.allowStandalone) || false);
    __privateSet(this, _queryParams, new URLSearchParams(window.location.search));
    this.id = __privateGet(this, _queryParams).get(MFE_INSTANCE_ID_QUERY_PARAM) || uuid();
  }
  async start(payload) {
    if (__privateGet(this, _hostMode) === HostModes.Standalone) {
      if (!__privateGet(this, _allowStandalone)) {
        throw new StandaloneNotAllowedError();
      }
      const jwt = __privateGet(this, _queryParams).get("jwt");
      const tokenPayload = { token: jwt };
      this.dispatchEvent(
        new CustomEvent(EventNames.APPLY_AUTH_TOKEN, {
          detail: new Message({
            name: EventNames.APPLY_AUTH_TOKEN,
            source: `${MFE_LOCATION}.${this.name}`,
            destination: `${MFE_LOCATION}.${this.name}`,
            instanceUuid: this.id,
            payload: tokenPayload
          })
        })
      );
      return Promise.resolve();
    }
    const result = new Promise((resolve, reject) => {
      const initialEmbedHandler = () => {
        this.removeEventListener(
          EventNames.EMBED_ACKNOWLEDGED,
          initialEmbedHandler
        );
        resolve();
      };
      try {
        this.addEventListener(
          EventNames.EMBED_ACKNOWLEDGED,
          initialEmbedHandler
        );
      } catch (error) {
        reject(error);
      }
    });
    __privateMethod(this, _StorableMfe_instances, listenForMessages_fn).call(this);
    __privateMethod(this, _StorableMfe_instances, embedded_fn).call(this, payload);
    __privateGet(this, _debug).call(this, " MFE ready, waiting for messsages ...");
    return result;
  }
  stop() {
    window.removeEventListener("message", __privateGet(this, _onMessageEvent));
    __privateGet(this, _debug).call(this, "Removed message event listener ...");
  }
  requestAuthToken() {
    __privateMethod(this, _StorableMfe_instances, postToHost_fn).call(this, { name: EventNames.REQUEST_AUTH_TOKEN });
  }
  updateTitle(title) {
    const payload = { title };
    __privateMethod(this, _StorableMfe_instances, postToHost_fn).call(this, {
      name: EventNames.UPDATE_TITLE,
      payload
    });
  }
  updateDisplay(payload) {
    __privateMethod(this, _StorableMfe_instances, postToHost_fn).call(this, {
      name: EventNames.UPDATE_DISPLAY,
      payload
    });
  }
  completed() {
    __privateMethod(this, _StorableMfe_instances, postToHost_fn).call(this, { name: EventNames.COMPLETED });
  }
  cancelled() {
    __privateMethod(this, _StorableMfe_instances, postToHost_fn).call(this, { name: EventNames.CANCELLED });
  }
  fatalErrorEncountered(message) {
    const payload = { message };
    __privateMethod(this, _StorableMfe_instances, postToHost_fn).call(this, {
      name: EventNames.FATAL_ERROR_ENCOUNTERED,
      payload
    });
  }
  closingAcknowledged() {
    __privateMethod(this, _StorableMfe_instances, postToHost_fn).call(this, { name: EventNames.CLOSING_ACKNOWLEDGED });
  }
  closingCancelled(message) {
    const payload = { message };
    __privateMethod(this, _StorableMfe_instances, postToHost_fn).call(this, {
      name: EventNames.CLOSING_CANCELLED,
      payload
    });
  }
  sendMessage(payload) {
    __privateMethod(this, _StorableMfe_instances, postToHost_fn).call(this, {
      name: EventNames.MFE_MESSAGE,
      payload
    });
  }
};
_hostMode = new WeakMap();
_hostOrigin = new WeakMap();
_allowStandalone = new WeakMap();
_debug = new WeakMap();
_queryParams = new WeakMap();
_StorableMfe_instances = new WeakSet();
embedded_fn = function(payload) {
  __privateMethod(this, _StorableMfe_instances, postToHost_fn).call(this, {
    name: EventNames.EMBEDDED,
    payload: { ...payload, mfeUrl: window.location.href }
  });
};
detectHostMode_fn = function() {
  var _a, _b;
  if ((_a = window.storable) == null ? undefined : _a.mfeHost) {
    if ((_b = window.chrome) == null ? undefined : _b.webview) {
      return HostModes.WebView;
    }
    return HostModes.Direct;
  }
  if (window.self !== window.top) {
    return HostModes.iFrame;
  }
  return HostModes.Standalone;
};
_onMessageEvent = new WeakMap();
listenForMessages_fn = function() {
  window.addEventListener("message", __privateGet(this, _onMessageEvent));
};
postToHost_fn = function(partialMessage) {
  if (__privateGet(this, _hostMode) === HostModes.Standalone) {
    if (!__privateGet(this, _allowStandalone)) {
      throw new StandaloneDispatchError();
    }
    __privateGet(this, _debug).call(this, "This message has been ignored because the application is in Standalone mode.", partialMessage);
    return;
  }
  const message = new Message({
    name: partialMessage.name,
    source: `${MFE_LOCATION}.${this.name}`,
    destination: `${APP_LOCATION}.whatever`,
    instanceUuid: this.id,
    payload: partialMessage.payload || {}
  });
  let origin = __privateGet(this, _hostOrigin);
  if (origin === undefined) {
    if (message.isNamed(EventNames.EMBEDDED)) {
      origin = "*";
    } else {
      throw new InsecureDispatchError();
    }
  }
  let destination = window;
  if (__privateGet(this, _hostMode) === HostModes.iFrame) {
    destination = window.parent;
  }
  __privateGet(this, _debug).call(this, " -> MFE to Host", message);
  destination.postMessage(message, origin);
};

export { StorableMfe };
